import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserServiceCreateResponseJson } from '@vmspdb/definitions';
import { Paginated } from '@vmspdb/ui/domain';
import * as fromPaginatedUser from './paginated-user.reducer';

export const selectPaginatedUserState =
  createFeatureSelector<fromPaginatedUser.PaginatedUserState>(
    fromPaginatedUser.paginatedUserFeatureKey,
  );

export const selectPaginatedUsers = createSelector(
  selectPaginatedUserState,
  (state): Paginated<UserServiceCreateResponseJson> => state,
);

export const selectPaginatedUserError = createSelector(
  selectPaginatedUserState,
  (state) => state.error,
);
